module.exports = __webpack_public_path__ + "img/image23.fc3ec1b6.png";